"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Fax;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Fax(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Contact"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "fax"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "outline",
    d: "M29.271,52.748a3.992,3.992,0,1,1-3.992-3.992A3.992,3.992,0,0,1,29.271,52.748ZM92.557,39.866v36.96a6.017,6.017,0,0,1-6.01,6.01h-8.7v3.8A5.868,5.868,0,0,1,71.989,92.5H28.011a5.868,5.868,0,0,1-5.862-5.861v-3.8h-8.7a6.017,6.017,0,0,1-6.01-6.01V39.866a6.016,6.016,0,0,1,6.01-6.009h8.7v-20.5A5.868,5.868,0,0,1,28.011,7.5H71.989a5.868,5.868,0,0,1,5.862,5.861v20.5h8.7A6.016,6.016,0,0,1,92.557,39.866ZM71.989,12.5H63.807v6.847a1.863,1.863,0,0,0,1.861,1.861h7.183V13.361A.873.873,0,0,0,71.989,12.5ZM27.149,33.831h45.7V24.208H65.668a4.866,4.866,0,0,1-4.861-4.861V12.5h-32.8a.873.873,0,0,0-.862.861Zm45.7,35.7h-45.7V86.639a.873.873,0,0,0,.862.861H71.989a.873.873,0,0,0,.862-.861ZM87.557,39.866a1.023,1.023,0,0,0-1.01-1.009H13.453a1.023,1.023,0,0,0-1.01,1.009v36.96a1.023,1.023,0,0,0,1.01,1.01h8.7V67.03a2.5,2.5,0,0,1,2.5-2.5h50.7a2.5,2.5,0,0,1,2.5,2.5V77.836h8.7a1.023,1.023,0,0,0,1.01-1.01Z"
  }))));
}